'use client';

import type { UserType } from '~/model/UserType';
import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import appConst from '~/const/appConst';
import { CompleteProfileBannerWrapper } from './CompleteProfileBannerWrapper';

export const CompleteProfileBannerForm = ({ user }: { user: UserType }) => {
  const t = useTranslations();

  const { index, main_criterias, children_profile } = appConst.staticRoutes;

  return (
    <CompleteProfileBannerWrapper>
      <div
        data-testid="complete-profile"
        className="complete-profile__banner-buttons"
      >
        <Link
          className="vp-button button-wrapper-link"
          href={user?.child ? `${children_profile}/${user.id}` : main_criterias}
          prefetch={false}
        >
          <span className="vp-button__label" data-part="label">
            <div data-part="start-slot" data-testid="icon-timer">
              <VpIcon name="sparkles" />
            </div>
            {t('HOMEPAGE.COMPLETE_PROFILE.BANNER.BUTTON')}
          </span>
        </Link>
        <Link
          className="vp-button vp-button--inverse button-wrapper-link"
          href={index}
          prefetch={false}
        >
          <span className="vp-button__label" data-part="label">
            {t('GLOBAL.BACK_TO_HOME')}
          </span>
        </Link>
      </div>
    </CompleteProfileBannerWrapper>
  );
};
